export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_25-8243fbd86978457654ae8c6a3c9fb87b.jpg";